import { useMemo } from 'react';
import { config, isDevelopment, isProduction, isStaging } from '../config/environment';

interface EnvironmentConfig {
  apiUrl: string;
  environment: string;
  debug: boolean;
  version: string;
  isDevelopment: boolean;
  isProduction: boolean;
  isStaging: boolean;
}

export const useEnvironment = (): EnvironmentConfig => {
  return useMemo(() => ({
    apiUrl: config.apiUrl,
    environment: config.environment,
    debug: config.debug,
    version: config.version,
    isDevelopment,
    isProduction,
    isStaging,
  }), []);
};
